/**
 * DOM utilities
 */

/**
 * Query selector sicuro nel shadow DOM
 * @param {ShadowRoot} root - Shadow root
 * @param {string} selector - Selettore CSS
 * @returns {Element|null} Elemento trovato
 */
export function $(root, selector) {
  return root?.getElementById?.(selector.replace('#', '')) || 
         root?.querySelector?.(selector) || 
         null;
}

/**
 * Query selector all sicuro nel shadow DOM
 * @param {ShadowRoot} root - Shadow root
 * @param {string} selector - Selettore CSS
 * @returns {NodeList} Lista di elementi
 */
export function $$(root, selector) {
  return root?.querySelectorAll?.(selector) || [];
}

/**
 * Attacca event listener con controllo esistenza
 * @param {ShadowRoot} root - Shadow root
 * @param {string} selector - Selettore CSS
 * @param {string} event - Nome evento
 * @param {Function} handler - Handler
 * @returns {boolean} True se attaccato con successo
 */
export function attachListener(root, selector, event, handler) {
  const element = $(root, selector);
  if (element) {
    element.addEventListener(event, handler);
    return true;
  }
  return false;
}

/**
 * Aggiorna attributo data
 * @param {ShadowRoot} root - Shadow root  
 * @param {string} selector - Selettore CSS
 * @param {string} attr - Nome attributo
 * @param {string} value - Valore
 */
export function setDataAttr(root, selector, attr, value) {
  const element = $(root, selector);
  if (element) {
    if (value) {
      element.setAttribute(attr, value);
    } else {
      element.removeAttribute(attr);
    }
  }
}

